import { getPlans } from 'src/legacy_graphql'
import { useQueries, useSelector } from '.'

const usePlansSubscriptions = () => {
  const {
    user: { account },
  } = useSelector(state => state)

  const [plans] = useQueries(getPlans())

  const newPlanStripeId = account?.stripeSubscription?.metadata?.planOnCancel
  const newPlan = plans.find(plan => plan.stripeId === newPlanStripeId)

  return {
    currentSubscription: account?.stripeSubscription,
    currentPlan: account?.plan,
    newPlan,
  }
}

export default usePlansSubscriptions
